import { Link, useNavigate } from "react-router-dom";
import { useReducer, useState } from 'react';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { InformacaoBasicaDTO } from "../../Model/Estimativa/InformacaoBasicaDTO";
import CurrencyInput from 'react-currency-input-field';
import ErrorModal from "../Common/ErrorModal";
import { EnumOperacao } from "../../Model/Estimativa/EnumOperacao";
import * as Constants from "../../Constants/constants";
import { ClearSession } from "../Common/Helper";


export default function BasicInformationForm({ tipoOperacaoDTO }) {
    // Session
    const clearSession = async () => { return await ClearSession() };
    // state
    const [errors, setErrors] = useState({});
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [continuing, setContinuing] = useState(false);

    // reducer
    const [informacaoBasicaDTO, dispatch] = useReducer(informacaoBasicaReducer, { ...new InformacaoBasicaDTO(), TipoOperacao: tipoOperacaoDTO.Operacao });
    // other
    const navigate = useNavigate();
    const enumOperacao = EnumOperacao;

    // Reducer implementation
    function informacaoBasicaReducer(informacaoBasicaDTO, action) {
        if (action.valor === undefined)
            return { ...informacaoBasicaDTO };

        switch (action.type) {
            case 'TIME-IN': return { ...informacaoBasicaDTO, EntradaEstimada: action.valor };
            case 'TIME-OUT': return { ...informacaoBasicaDTO, SaidaEstimada: action.valor };
            case 'QTD-CONTAINERS': return { ...informacaoBasicaDTO, QtdContainers: parseInt(action.valor) < 0 ? 0 : parseInt(action.valor) };
            case 'TAMANHO-CONTAINER': return { ...informacaoBasicaDTO, TamanhoContainer: action.valor };
            case 'TRANSPORTE-VAZIO': return { ...informacaoBasicaDTO, Transporte: action.valor };
            case 'IMO': return { ...informacaoBasicaDTO, CargaImo: action.valor };
            case 'OOG': return { ...informacaoBasicaDTO, CargaOOG: action.valor };
            case 'REEFER': return { ...informacaoBasicaDTO, CargaReefer: action.valor };
            case 'ANVISA': return { ...informacaoBasicaDTO, CargaAnvisa: action.valor };
            case 'TONELAGEM': return { ...informacaoBasicaDTO, Tonelagem: parseInt(action.valor) < 0 ? 0 : parseInt(action.valor) };
            case 'VOLUME': return { ...informacaoBasicaDTO, Volume: parseInt(action.valor) < 0 ? 0 : parseInt(action.valor) };
            default:
                break;
        }

        // CIF Real Calculado
        let cifRealCalculado = 0;
        if (action.type === 'CIF') {
            let cifFloat = parseFloat(action.valor.replace(',', '.'));
            if (informacaoBasicaDTO.TaxaCambioReal != undefined) {
                let cambioFloat = parseFloat(informacaoBasicaDTO.TaxaCambioReal.replace(',', '.'));
                cifRealCalculado = Math.round((cambioFloat * cifFloat + Number.EPSILON) * 100) / 100
            }
            return {
                ...informacaoBasicaDTO,
                ValorCifDolar: action.valor,
                ValorCifReal: cifRealCalculado.toString().replace('.', ',')
            }
        }

        if (action.type === 'CAMBIO') {
            let cambioFloat = parseFloat(action.valor.replace(',', '.'));
            if (informacaoBasicaDTO.ValorCifDolar != undefined) {
                let cifFloat = parseFloat(informacaoBasicaDTO.ValorCifDolar.replace(',', '.'));
                cifRealCalculado = cambioFloat * cifFloat;
            }
            return {
                ...informacaoBasicaDTO,
                TaxaCambioReal: action.valor,
                ValorCifReal: cifRealCalculado.toString().replace('.', ',')
            }
        }

    }

    async function handleCancelarClick(e) {
        e.preventDefault();
        await clearSession();
        navigate('/StartSimulation');
    }

    async function handleContinuarClick(e) {
        e.preventDefault();
        const newErrors = {};
        if (validateForm()) {
            try {
                setContinuing(true);
                const response = await fetch(
                    Constants.BasicInformationConstants.ENDPOINT_ATUALIZARINFORMACAOBASICA,
                    { ...Constants.CommonConstants.DEFAULT_POST_REQUEST_OPTIONS, body: JSON.stringify(informacaoBasicaDTO) }
                )

                const result = await response.json();
                if (result.success === true)
                    navigate('/ComplementaryServices', { state: tipoOperacaoDTO })
                else {
                    newErrors.result = result.userFriendlyMessage;
                    console.log(result.technicalMessage);
                    if (result.technicalMessage.startsWith("No session"))
                        navigate('/StartSimulation');
                }

            }
            catch (error) {
                newErrors.result = "Não foi possível registrar as informações básicas, tente novamente mais tarde.";
                console.log(error);
            }
            finally {
                setContinuing(false);
                if (Object.keys(newErrors).length > 0) {
                    setErrors(newErrors);
                    setShowErrorModal(true);
                }
            }


        } else {
            setShowErrorModal(true);
        }
    }

    //Validations
    function validateForm() {
        let isValid = true;
        const newErrors = {};

        // Válido para todas as operações.
        if (informacaoBasicaDTO.EntradaEstimada > informacaoBasicaDTO.SaidaEstimada)
            newErrors.entradaSaidaEstimada = "Data de saída deve ser maior que a data de entrada.";

        if (tipoOperacaoDTO.Operacao !== enumOperacao.CntVazio
            && tipoOperacaoDTO.Operacao !== enumOperacao.ExportacaoCnt
            && tipoOperacaoDTO.Operacao !== enumOperacao.Cabotagem
            && tipoOperacaoDTO.Operacao !== enumOperacao.ExportacaoCs)
            // Comum a todas exceto contêiner vazio e exportação.    
            validateFormCommon(newErrors);

        // Comum a operação de contêineres de movo geral
        if (![enumOperacao.ExportacaoCs, enumOperacao.LCL].includes(tipoOperacaoDTO.Operacao)) {
            validateFormContainer(newErrors)
            // apenas para contêineres cheios
            if (tipoOperacaoDTO.Operacao === enumOperacao.FCL) {
                validateFormFullContainer(newErrors);
            }

            if (tipoOperacaoDTO.Operacao === enumOperacao.FCLDesovado) {
                validateFormCargaSolta(newErrors)
            }
        }
        else {
            //Apenas carga solta
            validateFormCargaSolta(newErrors)
        }


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            isValid = false
        }

        return isValid;

    }

    function validateFormCommon(prNewErrors) {

        // Taxa de câmbio
        if (parseFloat(informacaoBasicaDTO.TaxaCambioReal == undefined ? '0' : informacaoBasicaDTO.TaxaCambioReal.replace(',', '.')) <= 0) {
            prNewErrors.taxaCambioReal = "Taxa de câmbio em reais deve ser preenchida com um valor maior que zero."
        }
        // Valor CIF
        if (parseFloat(informacaoBasicaDTO.ValorCifDolar == undefined ? '0' : informacaoBasicaDTO.ValorCifDolar.replace(',', '.')) <= 0) {
            prNewErrors.valorCifDolar = "Valor CIF em dólares deve ser preenchida com um valor maior que zero."
        }

    }

    function validateFormContainer(prNewErrors) {

        if (parseInt(informacaoBasicaDTO.QtdContainers == undefined ? '0' : informacaoBasicaDTO.QtdContainers) <= 0) {
            prNewErrors.QtdContainers = "Quantidade de contêineres deve ser preenchida com número maior do que zero."
        }

        if (parseInt(informacaoBasicaDTO.TamanhoContainer == undefined ? '0' : informacaoBasicaDTO.TamanhoContainer) === 0) {
            prNewErrors.TamanhoContainer = "Tamanho do contêiner deve ser selecionado."
        }

    }

    function validateFormFullContainer(prNewErrors) {

        if (informacaoBasicaDTO.CargaOOG === true) {
            if (informacaoBasicaDTO.CargaAnvisa || informacaoBasicaDTO.CargaReefer || informacaoBasicaDTO.CargaImo) {
                prNewErrors.CargaOOG = "Carga OOG não pode ser Reefer, IMO ou Anvisa.";
            }
        }

    }

    function validateFormCargaSolta(prNewErrors) {

        if (parseInt(informacaoBasicaDTO.Tonelagem == undefined ? '0' : informacaoBasicaDTO.Tonelagem) <= 0) {
            prNewErrors.Tonelagem = "Para carga solta, tonelagem deve ser preenchida com número maior do que zero."
        }

        if (parseInt(informacaoBasicaDTO.Volume == undefined ? '0' : informacaoBasicaDTO.Volume) === 0) {
            prNewErrors.Volume = "Para carga solta, volume deve ser preenchido com número maior do que zero."
        }

        if (informacaoBasicaDTO.CargaAnvisa && informacaoBasicaDTO.CargaImo) {
            prNewErrors.CargaAnvisa = "Para carga solta, IMO e Anvisa não devem estar selecionados ao mesmo tempo.";
        }

    }


    return (
        <form>
            <div className="space-y-6">

                <div className="border-b border-gray-900/10 pb-12">

                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-6">

                        <div className="sm:col-span-3" >
                            <label htmlFor="time-in" className="block text-sm font-medium leading-6 text-gray-900">Entrada prevista</label>
                            <div className="relative mt-2 rounded-md shadow-sm">
                                <DatePicker
                                    name="time-in"
                                    id="time-in"
                                    onChange={
                                        e => { dispatch({ type: 'TIME-IN', valor: e }) }
                                    }
                                    value={informacaoBasicaDTO.EntradaEstimada}
                                    format='dd/MM/yyyy'
                                    dayPlaceholder='dd'
                                    monthPlaceholder='mm'
                                    yearPlaceholder='aaaa'
                                    wrapperClassName='rounded-3xl p-2.5' />
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="time-out" className="block text-sm font-medium leading-6 text-gray-900">Saída prevista</label>
                            <div className="relative mt-2 rounded-md shadow-sm">
                                <DatePicker name="time-out" id="time-out" onChange={e => { dispatch({ type: 'TIME-OUT', valor: e }) }
                                } value={informacaoBasicaDTO.SaidaEstimada} format='dd/MM/yyyy' dayPlaceholder='dd' monthPlaceholder='mm' yearPlaceholder='aaaa' />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="cambio" className="block text-sm font-medium leading-6 text-gray-900">Taxa de câmbio em R$</label>
                            <div className="relative mt-2 rounded-md shadow-sm">
                                <CurrencyInput
                                    name="cambio"
                                    id="cambio"
                                    disabled={[enumOperacao.CntVazio, enumOperacao.ExportacaoCnt, enumOperacao.Cabotagem, enumOperacao.ExportacaoCs].includes(tipoOperacaoDTO.Operacao)}
                                    onValueChange={(value) => dispatch({ type: 'CAMBIO', valor: value == undefined ? ',00' : value })}
                                    value={informacaoBasicaDTO.TaxaCambioReal}
                                    placeholder='R$ 0,00'
                                    decimalScale={4}
                                    decimalsLimit={4}
                                    intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                                    className="block w-full rounded-md border-0 m py-1.5 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6  disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>
                        </div>


                        <div className="sm:col-span-2">
                            <label htmlFor="cif" className="block text-sm font-medium leading-6 text-gray-900">CIF em US$</label>
                            <div className="relative mt-2 rounded-md shadow-sm">
                                <CurrencyInput
                                    name="cif"
                                    id="cif"
                                    disabled={[enumOperacao.CntVazio, enumOperacao.ExportacaoCnt, enumOperacao.Cabotagem, enumOperacao.ExportacaoCs].includes(tipoOperacaoDTO.Operacao)}
                                    onValueChange={(value) => dispatch({ type: 'CIF', valor: value == undefined ? ',00' : value })}
                                    value={informacaoBasicaDTO.ValorCifDolar}
                                    placeholder='US$ 0,00'
                                    decimalScale={2}
                                    intlConfig={{ locale: 'pt-BR', currency: 'USD' }}
                                    className="block w-full rounded-md border-0 m py-1.5 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6  disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="cif_real" className="block text-sm font-medium leading-6 text-gray-900">CIF convertido para R$</label>
                            <div className="relative mt-2 rounded-md shadow-sm">
                                <CurrencyInput
                                    disabled={true}
                                    name="cif_real"
                                    id="cif_real"
                                    value={informacaoBasicaDTO.ValorCifReal}
                                    placeholder='R$ 0,00'
                                    decimalScale={2}
                                    intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                                    className="block w-full rounded-md border-0 m py-1.5 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="qtd-containers" className="block text-sm font-medium leading-6 text-gray-900">Quantidade de {tipoOperacaoDTO.Operacao === EnumOperacao.LCL || tipoOperacaoDTO.Operacao === EnumOperacao.ExportacaoCs ? " lotes" : " contêineres"}</label>
                            <div className="mt-2">
                                <input id="qtd-containers" name="qtd-containers"
                                    onChange={e => { dispatch({ type: 'QTD-CONTAINERS', valor: e.target.value }) }}
                                    value={informacaoBasicaDTO.QtdContainers}
                                    type="number" placeholder="0" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6  disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="tamanho-container" className="block text-sm font-medium leading-6 text-gray-900">Tamanho</label>
                            <div className="mt-2">
                                <select id="tamanho-container" name="tamanho-container"
                                    onChange={e => { dispatch({ type: 'TAMANHO-CONTAINER', valor: e.target.selectedIndex }) }}
                                    disabled={[enumOperacao.ExportacaoCs, enumOperacao.LCL].includes(tipoOperacaoDTO.Operacao)}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none">
                                    <option>N/A</option>
                                    <option>20'</option>
                                    <option>40'</option>
                                </select>
                            </div>
                        </div>

                        <div className="sm:col-span-2">
                            <label htmlFor="transporte-vazio" className="block text-sm font-medium leading-6 text-gray-900">Transporte (contêiner vazio)</label>
                            <div className="mt-2">
                                <select id="transporte-vazio" name="transporte-vazio"
                                    onChange={e => { dispatch({ type: 'TRANSPORTE-VAZIO', valor: e.target.selectedIndex }) }}
                                    disabled={![enumOperacao.CntVazio].includes(tipoOperacaoDTO.Operacao)}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none">
                                    <option>N/A</option>
                                    <option>Até 10KM</option>
                                    <option>De 10KM até 30KM</option>
                                    <option>Sepetiba</option>
                                </select>
                            </div>
                        </div>

                        <div className="sm:col-span-3">
                            <fieldset>
                                <legend className="text-sm font-semibold leading-6 text-gray-900">Características</legend>
                                <div className="mt-6 space-y-6">
                                    <div className="relative flex gap-x-3">
                                        <div className="flex h-6 items-center">
                                            <input id="IMO" name="IMO"
                                                disabled={[enumOperacao.CntVazio, enumOperacao.ExportacaoCnt, enumOperacao.ExportacaoCs, enumOperacao.Cabotagem].includes(tipoOperacaoDTO.Operacao)}
                                                onChange={(e) => { dispatch({ type: 'IMO', valor: e.target.checked }) }}
                                                type="checkbox" className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600  disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                                        </div>
                                        <div className="text-sm leading-6">
                                            <label htmlFor="IMO" className="font-medium text-gray-900">IMO</label>
                                            <p className="text-gray-500">Marque em caso de carga com classificação IMO</p>
                                        </div>
                                    </div>
                                    <div className="relative flex gap-x-3">
                                        <div className="flex h-6 items-center">
                                            <input id="OOG" name="OOG"
                                                disabled={!([enumOperacao.FCL, enumOperacao.ExportacaoCnt].includes(tipoOperacaoDTO.Operacao))}
                                                onChange={(e) => { dispatch({ type: 'OOG', valor: e.target.checked }) }}
                                                type="checkbox" className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600  disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                                        </div>
                                        <div className="text-sm leading-6">
                                            <label htmlFor="OOG" className="font-medium text-gray-900 ">OOG</label>
                                            <p className="text-gray-500">Marque em caso de carga com excesso em alguma dimensão</p>
                                        </div>
                                    </div>
                                    <div className="relative flex gap-x-3">
                                        <div className="flex h-6 items-center">
                                            <input id="reefer" name="reefer"
                                                disabled={!([enumOperacao.FCL, enumOperacao.Cabotagem, enumOperacao.ExportacaoCnt].includes(tipoOperacaoDTO.Operacao))}
                                                onChange={(e) => { dispatch({ type: 'REEFER', valor: e.target.checked }) }}
                                                type="checkbox" className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                                        </div>
                                        <div className="text-sm leading-6">
                                            <label htmlFor="reefer" className="font-medium text-gray-900">Reefer</label>
                                            <p className="text-gray-500">Marque caso a carga seja refrigerada</p>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="tonelagem" className="block text-sm font-medium leading-6 text-gray-900">Tonelagem (carga solta)</label>
                            <div className="mt-2">
                                <input id="tonelagem" name="tonelagem"
                                    onChange={e => { dispatch({ type: 'TONELAGEM', valor: e.target.value }) }}
                                    value={informacaoBasicaDTO.Tonelagem}
                                    disabled={!([enumOperacao.ExportacaoCs, enumOperacao.LCL, enumOperacao.FCLDesovado].includes(tipoOperacaoDTO.Operacao))}
                                    type="number" placeholder="0" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>

                            <label htmlFor="metros-cubicos" className="mt-7 block text-sm font-medium leading-6 text-gray-900">Metros cúbicos (em caso de carga solta)</label>
                            <div className="mt-2">
                                <input id="metros-cubicos" name="metros-cubicos"
                                    onChange={e => { dispatch({ type: 'VOLUME', valor: e.target.value }) }}
                                    value={informacaoBasicaDTO.Volume}
                                    disabled={!([enumOperacao.ExportacaoCs, enumOperacao.LCL, enumOperacao.FCLDesovado].includes(tipoOperacaoDTO.Operacao))}
                                    type="number" placeholder="0" className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                            </div>

                            <div className="relative flex gap-x-3 mt-7">
                                <div className="flex h-6 items-center">
                                    <input id="anvisa" name="anvisa"
                                        disabled={(!([enumOperacao.LCL, enumOperacao.FCLDesovado].includes(tipoOperacaoDTO.Operacao)))}
                                        onChange={(e) => { dispatch({ type: 'ANVISA', valor: e.target.checked }) }}
                                        type="checkbox" className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none" />
                                </div>
                                <div className="text-sm leading-6">
                                    <label htmlFor="anvisa" className="font-medium text-gray-900">Anvisa</label>
                                    <p className="text-gray-500">Carga Anvisa (apenas para carga solta)</p>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">

                <button type="button" onClick={handleCancelarClick} className="text-sm font-semibold leading-6 text-gray-900">Cancelar</button>
                <button
                    onClick={handleContinuarClick}
                    type="submit"
                    className="rounded-md bg-orange-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    {continuing ? "Aguarde..." : "Continuar"}
                    {continuing && <svg id="spinner" aria-hidden="true" class="inline ml-1 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>}
                </button>
            </div>
            <ErrorModal open={showErrorModal} onOpen={() => setShowErrorModal(false)} children={errors} />
        </form>
    )
}